import { isPreviewOrEditorMode, openPreviewPrompt } from 'widget/components/preview-prompt/preview-prompt';

export function notForPreview(target, key, descriptor) {
  if (_.isFunction(target)) {
    return function (...args) {

      if (isPreviewOrEditorMode()) {
        const [event] = args;

        if (_.get(event, 'preventDefault') && _.get(event, 'stopPropagation')) {
          event.preventDefault();
          event.stopPropagation();
        }

        openPreviewPrompt();
        return;
      }

      return target(...args);
    };
  }

  const originMethod = target[key];

  return {
    ...descriptor,
    value(event) {
      if (isPreviewOrEditorMode()) {
        if (_.get(event, 'preventDefault') && _.get(event, 'stopPropagation')) {
          event.preventDefault();
          event.stopPropagation();
        }

        openPreviewPrompt();
        return null;
      }

      return originMethod.apply(this, arguments);
    },
  };
}



// WEBPACK FOOTER //
// ./src/widget/utils/not-for-preview.js